import { I18n } from '@calendly/i18n'

import { useEventTypeContext } from 'features/event_type_provider'

import { AccordionPanel } from '../../../../components/accordion'
import { Assign } from '../../assign'

export const AssignPanel = (props) => {
  const { isCreation } = useEventTypeContext()

  return (
    <AccordionPanel
      titleId="assign-label"
      title={I18n.t('publisher.managed_event_types.event_type.section.title')}
      subheader={(isCreation
        ? I18n.t('publisher.managed_event_types.event_type.section.creation_subheader')
        : I18n.t('publisher.managed_event_types.event_type.section.subheader')
      )}
      {...props}
    >
      <Assign />
    </AccordionPanel>
  )
}
